import {assocPath} from 'ramda'

import {
  Booking,
  BookingStatus,
  MerchantOfRecord
} from '@vio/core/src/api-types/bovio/response/booking'
import {ExtendedBooking} from '@vio/core/src/booking/types/Booking'
import {hasPayAtPropertyPayment} from '@vio/core/src/offer/business/offerPaymentMode'

export const decorateOfferWithPayAtProperty = (
  booking: Booking
): ExtendedBooking => {
  const dealFreezePayAtProperty =
    booking?.status === BookingStatus.Frozen &&
    booking?.merchantOfRecord === MerchantOfRecord.Findhotel
  const payAtProperty =
    hasPayAtPropertyPayment(booking) || dealFreezePayAtProperty

  return assocPath(['payAtProperty'], payAtProperty, booking)
}
